import React, { useState } from "react";
import { Button } from "../components/ui/button";
import { api, API_BASE } from "../lib/api";
import { toast } from "sonner";
import { Loader2, Play, FileDown } from "lucide-react";

export const Topbar = ({ onRefresh }) => {
  const [running, setRunning] = useState(false);

  const runCrawl = async () => {
    setRunning(true);
    try {
      const run = await api.triggerCrawl({
        source_ids: [],
        use_llm: false,
        include_sample: true,
        max_pages: 1,
      });
      toast.info("Crawl started — waiting for results…");
      // Poll until finished
      const poll = (id) =>
        api.runDetail(id).then((r) => {
          if (r.status === "completed" || r.status === "failed") {
            if (r.status === "completed") {
              toast.success(`Crawl complete — ${r.opportunities_found} opportunities (${r.opportunities_new} new)`);
            } else {
              toast.error("Crawl failed");
            }
            onRefresh?.();
            setRunning(false);
          } else {
            setTimeout(() => poll(id), 2000);
          }
        });
      poll(run.id);
    } catch (e) {
      toast.error(`Crawl failed: ${e?.message || "error"}`);
      setRunning(false);
    }
  };

  const doExport = async (url, ext) => {
    try {
      const token = localStorage.getItem("token");
      const r = await fetch(url, {
        method: "POST",
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (!r.ok) throw new Error(r.statusText);
      const blob = await r.blob();
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `opportunities_${new Date().toISOString().slice(0,10)}.${ext}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(a.href);
      toast.success(`Exported as .${ext}`);
    } catch (e) {
      toast.error("Export failed");
    }
  };

  return (
    <header
      className="h-14 border-b border-zinc-200 bg-white flex items-center justify-between px-6 sticky top-0 z-20"
      data-testid="app-topbar"
    >
      <div>
        <div className="text-xs uppercase tracking-widest text-zinc-500 font-mono">
          PROCUREMENT INTELLIGENCE
        </div>
        <div className="text-sm font-semibold text-zinc-900 font-[Chivo]">
          Canadian RFP Crawler · HR / Payroll / ERP / Oracle / SAP / K-12
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => doExport(`${API_BASE}/export/csv?active_only=true`, "csv")}
          data-testid="export-csv-btn"
          className="rounded-sm border-zinc-300 text-zinc-700"
        >
          <FileDown size={14} className="mr-1.5" />
          Export CSV
        </Button>
        <Button
          size="sm"
          onClick={runCrawl}
          disabled={running}
          data-testid="run-crawl-btn"
          className="rounded-sm bg-[#002FA7] hover:bg-[#002175] text-white"
        >
          {running ? (
            <Loader2 size={14} className="mr-1.5 animate-spin" />
          ) : (
            <Play size={14} className="mr-1.5" />
          )}
          {running ? "Crawling…" : "Run Crawl Now"}
        </Button>
      </div>
    </header>
  );
};
